import React, { PureComponent } from 'react';
import './IBMPC.css';
import WIN from './WIN.js';
import ICONS from './ICONS';

class IBMPC extends PureComponent {
  constructor() {
    super();

    this.state = {
      stage: 'booting', // booting -> win -> shutoff
      bootupImagesLoaded: 0
    };

    this.bootmsg = [
      "AMIBIOS (C)1996 American Megatrends Inc.,<br><br>",
      "Intel Celeron - 333 MHz<br>",
      "Checking NVRAM", null, null,
      "..", "Update OK!<br>",
      "<br>","65587KB OK<br>",
      "Hit DEL if you want to run SETUP<br>",
      "<br>", 
      null, null,
      "Starting Windows 95...", "<br><br>",
    
      "This driver is provided by Oak Technology, Inc..<br>",
      "OTI-91X ATAP CD-ROM device driver, Rev D91XV352<br>",
      "(C)Copyright Oak Technology Inc. 1987-1996<br>",
      null, null];

    this.imagesLoaded = 0;

    let scrollKeeper = () => {
      window.scroll(0, 0);
      setTimeout(scrollKeeper, 1000);
    };
    setTimeout(scrollKeeper, 1000);
  }

  playAnimation(bootupDiv) {
    if (bootupDiv == null) {
      return;
    }
    
    var totalIms = Object.keys(ICONS).length;
    var i = 0;
    var timeout = () => {
      if (i >= this.bootmsg.length) {
        
        if (this.imagesLoaded >= totalIms) {
          this.setState({stage: 'win'});
        } else {
          setTimeout(timeout, 50); // Spin
        }
      } else {
        if ((this.imagesLoaded / totalIms) >= (i / this.bootmsg.length)) {
          if (this.bootmsg[i]) {
            bootupDiv.innerHTML += this.bootmsg[i];
          }
          i++;
        }
        setTimeout(timeout, 40);
      }
    };

    console.log("playing anim");

    setTimeout(timeout, 500);
  }

  shutoff() {
    this.setState({ stage: 'shutoff' });
  }

  render() {
    var stage;
    let bootupImageLoaded = () => this.setState({bootupImagesLoaded: this.state.bootupImagesLoaded + 1});

    if (this.state.stage === "booting") {
      stage = <div className="ibmpc-bootup" ref={elm => this.bootup = elm}>
        <div className="images">
          <img src={ICONS.BIOS} className="megatrends" onLoad={bootupImageLoaded} />
          <img src={ICONS.ENERSTAR} className="enerstar" onLoad={bootupImageLoaded} />
        </div>
        {this.state.bootupImagesLoaded >= 2 ? <div ref={this.playAnimation.bind(this)}></div> : null}
      </div>;
    } else if (this.state.stage === "win") {
      stage = <WIN shutoff={this.shutoff.bind(this)} />;
    } else if (this.state.stage === "shutoff") {
      stage = <div className="ibmpc-shutoff">
        <img src="/images/shutoff.png" />
      </div>;
    }

    return (
      <div className="ibmpc">
        {stage}

        <div className="image-loader">
          {Object.keys(ICONS).map((i) => <img key={i} src={ICONS[i]} onLoad={() => this.imagesLoaded += 1} />)}
        </div>
      </div>
    );
  }
}

export default IBMPC;



// WEBPACK FOOTER //
// ./src/walleris/IBMPC.js